import { Component, Element, h, Prop } from '@stencil/core';
import { CmsNavigationEntry, Logger } from '../../global/_types';

@Component({
  tag: 'dev-layout-footer',
  shadow: false
})

export class DevLayoutFooter {
  @Element() host: HTMLElement;

  @Prop() config: string | DevLayoutFooterConfig;
  @Prop() debug: boolean = false;

  private logger: Logger;

  /* Config */
  private options: DevLayoutFooterConfig;

  // Lifecycle
  componentWillLoad() {
    this.logger = new Logger(this.debug, 'Layout Footer');

    this.options = typeof(this.config) === 'string' ?
      JSON.parse(this.config) as DevLayoutFooterConfig :
      this.config;
  }

  componentDidLoad() {
    this.logger.trace('Layout Footer loaded');
  }

  // Render
  render() {
    const footerConfig = {
      "data": {
        'footer': this.options.footer
      },
      "type": "footer"
    };

    const footerMetaConfig = {
      "data": {
        'footerMeta': this.options.footerMeta
      },
      "type": "footerMeta"
    };

    const iconBarConfig = {
      "data": {
        'iconBar': this.options.iconBar
      },
      "type": "iconBar"
    };

    // noinspection HtmlUnknownAnchorTarget
    return ([
      <div class='hidden-xs'>
        <a href="#top" id="back">
          <span>Zurück zum Anfang</span>
          <span class='icon-raticons icon-arrow_btn_up' />
        </a>
      </div>,
      <footer>
        <div class="footer container-fluid no-padding">
          <div class="container">
            <div class="row">
              {
                footerConfig.data?.footer ?
                  <dev-layout-navigation debug={true} config={JSON.stringify(footerConfig)} />
                  : ''
              }
              <div class="col-xs-12 col-sm-4 col-md-3 newsletterForm">
                <ul>
                  <li>
                    RATIONAL-Newsletter abonnieren.
                    <span class="subheadline">Aktuelle Neuigkeiten rund um RATIONAL.</span>
                  </li>
                  <li>
                    <button id="nlSubBtn" class="stencil-button default" style={{ marginLeft: "0px" }}
                            type="submit">Abonnieren
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid socialBar p-b-70 ">
          <div class="container">
            {
              iconBarConfig.data?.iconBar ?
                <dev-layout-navigation debug={true} config={JSON.stringify(iconBarConfig)} />
                : ''
            }
            <div class="row">
              {
                footerMetaConfig.data?.footerMeta ?
                  <dev-layout-navigation debug={true} config={JSON.stringify(footerMetaConfig)} />
                  : ''
              }
              <div class="col-md-3">
                <p class="copyright">© 2023 RATIONAL. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    ]);
  }
}

export interface DevLayoutFooterConfig {
  footer: CmsNavigationEntry[] | null;
  iconBar: CmsNavigationEntry[] | null;
  footerMeta: CmsNavigationEntry[] | null;
}
